var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"width":"363px","height":"190px"},attrs:{"id":"heating-tube-overtemperature"}})}
var staticRenderFns = []

export { render, staticRenderFns }